import { useState } from 'react';
import ImageUploading from 'react-images-uploading';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";
import { v4 as uuidv4 } from 'uuid';

import PopupUpdateProfilePictureInSettings from '@/pages/artwork/artwork-header/options/download-template/components/PopupUpdateProfilePictureInSettings';
import UserService from '@/services/user.service';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';

import './styles/ProfileImage.css';

export default function ProfileImage({ userType, formState, setFormState }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);

  async function uploadProfileImage(image) {
    setImageToCrop(image);
    setIsPopupOpen(true);
  }

  async function handleCroppedImage(croppedFile) {
    const temporalImageId = uuidv4();

    setFormState({
      ...formState,
      user_image: {
        loading: true,
        temporalImageId,
        image_original_data: {
          name: croppedFile.name
        }
      }
    });

    const { response, data } = await UserService.uploadImage(croppedFile);

    if (response.ok) {
      setFormState(prevValue => {
        if (Boolean(prevValue.user_image) && prevValue.user_image.temporalImageId === temporalImageId) {
          return {
            ...prevValue,
            user_image: data
          };
        } else {
          return prevValue;
        }
      });
    } else {
      setFormState({
        ...formState,
        user_image: null
      });

      alert("Something went wrong. If the problem persists, contact us at contact@suarte.art.");
    }
  }

  function handleProfilePictureError(errors) {
    if (errors.maxNumber) alert("You are only allowed to upload one image.");
    else if (errors.acceptType) alert("Invalid image type.");
    else if (errors.maxFileSize) alert("File exceeds size limit (15 MB). Try uploading another.");
  }
  
  const cropShape = userType === 'gallery' ? 'rect' : 'circle';

  return (
    <>
      <ImageUploading
        maxNumber={1}
        onChange={(imagesList) => uploadProfileImage(imagesList[0].file)}
        onError={handleProfilePictureError}
        maxFileSize={15000000}
      >
        {({ onImageUpload }) => (
          <>
            <div className="profile-image__container">
              <UserProfileImage
                className="profile-image__image"
                image={formState.user_image?.image_id}
                typeOfProfile={userType}
                loading={formState.user_image?.loading}
              />

              {Boolean(formState.user_image) && <DeleteIcon className="profile-image__delete-image" onClick={() => setFormState({ ...formState, user_image: null })} />}
            </div>

            <Text className="profile-image__upload-image element-non-selectable" onClick={onImageUpload} medium>
              {
                formState.user_image ?
                  "Change picture"
                  :
                  "Add picture"
              }
            </Text>
          </>
        )}
      </ImageUploading>

      {isPopupOpen && (
        <PopupUpdateProfilePictureInSettings
          open={isPopupOpen}
          image={URL.createObjectURL(imageToCrop)}
          exitCrop={() => setIsPopupOpen(false)}
          continueCrop={() => setIsPopupOpen(false)}
          setCroppedFile={handleCroppedImage}
          cropShape={cropShape}
        />
      )}
    </>
  );
}
